import React from 'react';
import { Container } from './styles';
import { HiOutlineSearch } from 'react-icons/hi'

const InputSearch = ({ value, setValue, noIcon, minWidth, ...props }) => {

  return (
    <Container width={minWidth}>
      <input
        type='text'
        value={value}
        onChange={({ target }) => setValue(target.value)}
        {...props}
      />
      {!noIcon && <HiOutlineSearch size={20} />}
    </Container>
  )
}

export default InputSearch;
